import styled from 'styled-components';
import * as Dialog from '@radix-ui/react-dialog';
import { Image } from '@/shared/ui/image/Image';

export const StyledAlertDialogOverlay = styled(Dialog.Overlay)`
  position: fixed;
  background: rgba(39, 38, 43, 0.65);
  inset: 0;
  display: grid;
  z-index: 11;
  place-items: center;
  overflow-y: auto;
`;

export const StyledAlertDialogContent = styled(Dialog.Content)`
  position: fixed;
  top: 50%;
  left: 50%;
  box-shadow: 0px 0px 250px 50px #131315;
  background-color: #131315;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  max-height: 100vh;
  overflow: ${(props) => (props.$overflow ? props.$overflow : 'auto')};
  z-index: 100;
  @media screen and (max-width: 768px) {
    top: var(--app-safe-area-top);
    left: var(--app-safe-area-left);
    transform: translate(0, 0);
    box-shadow: none;
    width: calc(100% - var(--app-safe-area-left) - var(--app-safe-area-right));
    height: calc(
      100dvh - var(--app-safe-area-top) - var(--app-safe-area-bottom)
    );
    max-height: calc(
      100dvh - var(--app-safe-area-top) - var(--app-safe-area-bottom)
    );
    border-radius: 0;
  }

  @media (orientation: landscape) and (max-width: 1024px) and (max-height: 600px) {
    body.capacitor-ios & {
      display: flex;
      flex-direction: column;
      top: var(--app-safe-area-top);
      left: var(--app-safe-area-left);
      transform: translate(0, 0);
      box-shadow: none;
      width: calc(
        100% - var(--app-safe-area-left) - var(--app-safe-area-right)
      );
      height: calc(
        100dvh - var(--app-safe-area-top) - var(--app-safe-area-bottom)
      );
      max-height: calc(
        100dvh - var(--app-safe-area-top) - var(--app-safe-area-bottom)
      );
      border-radius: 0;
    }
  }
`;

export const AuthCloseIconImage = styled(Image)`
  position: absolute;
  top: calc(18px + var(--app-safe-area-top));
  right: calc(18px + var(--app-safe-area-right));
  cursor: pointer;
  z-index: 100;
`;

export const CloseIconImage = styled(Image)`
  position: absolute;
  top: calc(20px + var(--app-safe-area-top));
  right: calc(24px + var(--app-safe-area-right));
  cursor: pointer;
`;
